import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../../scss/theme';
import fnc from "../mymod/commFunction";
import './MyRoom_admin.scss';
import HongButton from "../comm/HongButton";
import HeaderTitle from "../comm/HeaderTitle";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FiBarChart2, FiInfo, FiAlertCircle   } from 'react-icons/fi';
import { FaCircle } from 'react-icons/fa';  



import { useNavigate, useLocation } from "react-router-dom";
import { setSelectedUserInfo, setVideoEduKind, setBoardKindTarget, setSelectedUserInfo_tec,
            setSelectedStStatus } from "../../reduxToolkit/redux";


const MyRoom_admin = ({ closeMobileMenu }) => {
    const userInfo = useSelector((state) => state.appReducer.userInfo);
    const videoEduKind = useSelector((state) => state.appReducer.videoEduKind);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [activeMenuItem, setActiveMenuItem] = useState(null); // 초기값을 null로 설정


    useEffect(() => {
        // 🎯 로그인 후 메인 페이지('/myRoomAca')에 있을 때만 자동 redirect
        if (location.pathname === '/myRoomAca' && userInfo) {
            // handleAssessment();
            // setActiveMenuItem('학원장진단');
        }
    }, [location.pathname, userInfo]);

    function handleRegAcaTec() {
        setActiveMenuItem('강사등록');
        navigate('/regAcaTec', { state: {
                isShowCloseBtn: false 
            }});
        closeMobileMenu && closeMobileMenu(); // 모바일에서 메뉴 닫기
    }

    function handleRegAcaStu() {
        setActiveMenuItem('학생등록');
        navigate('/regAcaStu', { state: {
                isShowCloseBtn: false 
        }});
        closeMobileMenu && closeMobileMenu(); 
    }



    function handleOpenStatus_users(title) {
        setActiveMenuItem(title);
        navigate('/admin/users', { state: {   
            isShowCloseBtn: false,
            title
        }});
        closeMobileMenu && closeMobileMenu(); 
    }   


    //=============================================

    return (


        <div className="MyRoom_admin">
            <div className="title">관리자</div>
            <Menu>

                <SubMenu 
                    label="회원 관리" 
                    icon={<FaCircle size={8} />}
                    defaultOpen={true}
                >
                

                    <MenuItem 
                        icon={<FaCircle size={5} />}
                        onClick={() => handleOpenStatus_users('회원 내역')}
                        active={activeMenuItem === '회원 내역'}
                    >
                        회원 내역
                    </MenuItem>
            

                </SubMenu>


                <SubMenu 
                    label="게시판 관리" 
                    icon={<FaCircle size={8} />}
                    defaultOpen={true}
                >
                    {/* <MenuItem 
                        icon={<FaCircle size={5} />}
                        onClick={() => handlePartner('광고 | 협력사 제휴 문의')}
                        active={activeMenuItem === '광고 | 협력사 제휴 문의'}
                    >
                        광고 | 협력사 제휴 문의
                    </MenuItem> */}

                </SubMenu>



        </Menu>
        </div>

    );
};

export default MyRoom_admin;
